import React from "react";
import { Button } from "@bca/ui-library";
import analytics from "../../common/analytics/analytics"; 
import { IEventPushable } from "../../common/analytics/analytics.types";

const pushSelectAnalytics = () => {
  analytics.push<IEventPushable>({
    event: {
      name: "click",
      category: "button",
      label: "back-top-top",
      action: "navigate",
    }
  });
};

const BackToTopButton:React.FC = () => {

  const scrollUp = ():void => {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
    pushSelectAnalytics();
  }

   const buttonStyling = () => {
     return (
      `z-index: 10;
      width: 42px;
      height:42px;
      padding: 14px;
      & div {
        margin: 0px;
      }`
    )}

  return(
        <Button 
            data-en="click" data-ec="button" data-el="back-to-top" data-ea="navigate" data-es="" data-testid="icon-container-arrow-up"
            icon="arrow-up"
            onClick={scrollUp}
            css={buttonStyling()}>
        </Button>
    )
  }

  export default BackToTopButton;